package br.com.heyagenda.domain.usecase

import br.com.heyagenda.domain.repository.AuthRepository

class DeleteAccountUseCase(
    private val authRepository: AuthRepository
) {
    fun getAuthProvider(): String = authRepository.getAuthProvider()

    suspend operator fun invoke(password: String? = null): Result<Unit> {
        return authRepository.deleteAccount(password)
    }
}
